import { formatCurrency, formatDate, formatStatus } from '@/lib/helpers';
import type { Transaction } from '@/types';
import type { TransactionUI } from '../types';

type PaystackMeta = {
  paystackResponse?: {
    amount?: number;
    fees?: number;
    authorization?: {
      account_name?: string | null;
      receiver_bank_account_number?: string | null;
      receiver_bank?: string | null;
    };
  };
};

export function transformTransaction(item: Transaction): TransactionUI {
  const { status, label } = formatStatus(item.status || '');
  const dateSource = item.paidAt ?? item.createdAt;
  const dates = formatDate(dateSource);
  const meta = (item.metaData || {}) as PaystackMeta;

  const grossKobo = meta.paystackResponse?.amount;
  const feesKobo = meta.paystackResponse?.fees;
  const platformChargeAmount =
    typeof feesKobo === 'number' ? formatCurrency(feesKobo / 100) : undefined;
  const netPayoutAmount =
    typeof grossKobo === 'number' && typeof feesKobo === 'number'
      ? formatCurrency((grossKobo - feesKobo) / 100)
      : undefined;

  const authorization = meta.paystackResponse?.authorization;

  return {
    id: item.id?.toString() ?? '',
    refId: item.reference ?? '',
    orderId: item.orderId ?? undefined,
    amount: item.amount ?? '',
    platformChargeAmount,
    netPayoutAmount,
    accountName: authorization?.account_name || undefined,
    bankAccountNumber: authorization?.receiver_bank_account_number || undefined,
    bankName: authorization?.receiver_bank || undefined,
    paymentMethod: item.paymentMethod ?? '',
    accountNumber: item.accountNumber ?? '',
    transactionType: item.transactionType ?? '',
    method: item.paymentMethod ?? '',
    gateway: item.paymentProvider ?? '',
    status,
    statusLabel: label,
    date: dates.date,
    fullDate: dates.fullDate,
  };
}

export function transformTransactions(items: Transaction[]): TransactionUI[] {
  return items.map(transformTransaction);
}
